module.exports = __webpack_public_path__ + "static/img/productpages.f19ddcda.jpg";